import React, { useState } from 'react';
import { API_BASE_URL } from '../config/api';

const states = 'AL AK AZ AR CA CO CT DE DC FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI WY AS GU MP PR VI'.split(' ');
export default function CustomerLicense({ number, state, international, apiCall }) {
  const [saved, setSaved] = useState(null);
  const [entry, setEntry] = useState({ driverLicenseNumber: '', driverLicenseState: '' });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const licenseNumber = saved?.driverLicenseNumber || number;
  const licenseState = saved?.driverLicenseState || state;
  const locked = Boolean(licenseNumber?.trim() || licenseState?.trim());
  const submit = async e => {
    e.preventDefault();
    setBusy(true); setError(null);
    try {
      const result = await apiCall(`${API_BASE_URL}/auth/license`, { method: 'POST', body: JSON.stringify(entry) });
      setSaved(result);
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  return <section className="tg-card tg-card-pad">
    <div className="tg-card-title"><h2>Driver license</h2></div>
    {locked ? <>
      <dl className="tg-license-details"><dt>License number</dt><dd>{licenseNumber || 'Not provided'}</dd><dt>State</dt><dd>{licenseState || 'Not provided'}</dd>{international !== undefined && <><dt>International</dt><dd>{international ? 'Yes' : 'No'}</dd></>}</dl>
      <p>License details are saved. Contact your rental office for corrections.</p>
    </> : <form className="tg-form" onSubmit={submit}>
      <p>You can enter your license details once. Check both fields before saving; changes require help from your rental office.</p>
      <label htmlFor="license-number">License number</label>
      <input id="license-number" required maxLength={20} pattern="[a-zA-Z0-9 \-]+" value={entry.driverLicenseNumber} disabled={busy}
        onChange={e => setEntry({ ...entry, driverLicenseNumber: e.target.value })} />
      <label htmlFor="license-state">Issuing state or territory</label>
      <select id="license-state" required value={entry.driverLicenseState} disabled={busy}
        onChange={e => setEntry({ ...entry, driverLicenseState: e.target.value })}>
        <option value="">Select state</option>{states.map(s => <option key={s}>{s}</option>)}
      </select>
      {error && <p role="alert" className="tg-form-msg error">{error}</p>}
      <button className="tg-btn primary" type="submit" disabled={busy}>{busy ? 'Saving…' : 'Save license details'}</button>
    </form>}
  </section>;
}
